<template>
<div id="root">
  <div id="app">
    <Countdown/>

    <div>
      <a class="link" href="https://youtu.be/E3Huy2cdih0"><div>Trailer</div></a>
      <a class="link" href="https://www.reddit.com/r/eldenring"><div>Reddit</div></a>
    </div>

    <!--div class="authors"></div-->

  </div>
</div>
</template>

<script>
import Countdown from './components/Countdown.vue'

export default {
  name: 'App',
  components: {
    Countdown
  },
}
</script>

<style>

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #b96f32f3;
  font-weight: bold;
  margin-top: 10vh;
  font-size: 3vh;
  position: relative;
}


html {
  background: url("./assets/background.png") no-repeat center center fixed; 
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  overflow: auto;
}

.link{
  background:black;
  display: inline-block;
  margin: 3vh;
  color: #b96f32f3;
  opacity: 0.9;
  border: 0.3vh solid;
  padding: 3vh;
  border-radius: 3vh;
  text-decoration: none;
}

.authors {
  color: #b96f32f3;
  bottom: 0;
  left: 0;
  font-weight: normal;
  font-size: smaller;
  border: 0.25vh solid;
  display: inline-block;
  background: black;
  margin: 1vh;
  margin-top: 5vh;
  padding: 1vh;
  border-radius: 2vh;
  opacity: 0.9;
}

</style>
